import { Routes } from '@angular/router';

import { ClientConfigProductName } from '@frontend/vanilla/core';

import { allowedProductGuard, clientConfigAppGuard } from '../guards';

export default [
    {
        path: 'bingo',
        loadChildren: () => import('@frontend/bingo/entrypoint-lib').then((t) => t.BingoRoutesModule),
        canMatch: [allowedProductGuard, clientConfigAppGuard],
        data: { product: ClientConfigProductName.BINGO },
    },
] satisfies Routes;
